import { gql } from '@apollo/client'

export const trackPageMetric = gql`
  mutation TrackPageMetric($page: String!, $type: String!, $block: String) {
    trackPageMetric(page: $page, type: $type, block: $block)
  }
`
